;(function () {
  'use strict'

  angular.module('pub.sets.service', []).factory('SetsService', SetsService)

  /** @ngInject */
  function SetsService($http, $q, API) {
    function list(parentId, t, start, limit, sort) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'publisher/channels/' +
            parentId +
            '/sets/search?t=' +
            t +
            '&start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/sets/' + id).success(defered.resolve)

      return defered.promise
    }

    function adminGet(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/sets/' + id).success(defered.resolve)

      return defered.promise
    }

    function getChannelId(parentId, sort, filter, enrich) {
      var defered = $q.defer()

      if (filter) {
        filter = '&onsale=' + filter
      } else {
        filter = ''
      }
      if (enrich) {
        enrich = '&enrich=' + enrich
      } else {
        enrich = ''
      }

      $http
        .get(
          API.API_URL + 'publisher/channels/' + parentId + '/sets?sort=' + sort + filter + enrich,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function getOneChannelId(parentId, id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/channels/' + parentId + '/sets/' + id)
        .success(defered.resolve)

      return defered.promise
    }

    function getId(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/sets/' + id).success(defered.resolve)

      return defered.promise
    }

    function save(parentId, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + parentId + '/sets', model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function clone(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id + '/clone')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function processBatch(payload) {
      var defered = $q.defer()

      $http
        .post(API.API_URL_RPC + 'set/batch', payload)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(parentId, id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + parentId + '/sets/' + id, model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function update2(id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id, model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/sets/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function reorder(channelId, setId, order) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/channels/' + channelId + '/sets/' + setId + '/order/' + order)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function nextEdition(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id + '/print_edition')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function mintableCollectibles(id, mintable) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id + '/mintable_collectibles?mintable=' + mintable)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function fixOrder(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id + '/leaderboard/order/reset')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function fixTop100(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/sets/' + id + '/leaderboards/value/user')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listProductLines() {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/product_lines').success(defered.resolve)

      return defered.promise
    }

    function listRoyalties(pId) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/publishers/' + pId + '/royalties').success(defered.resolve)

      return defered.promise
    }

    function addRoy(parentId, id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + parentId + '/royalties/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeRoy(parentId, id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/sets/' + parentId + '/royalties/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listTranslations(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/sets/' + id + '/set_translations')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getTranslation(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/set_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function createTranslation(id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id + '/set_translations?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateTranslation(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/set_translations/' + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeTranslation(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/set_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function createChecklistBlank(setId, expiredAt) {
      var defered = $q.defer()

      $http
        .post(
          API.API_URL +
            'admin/checklist_definitions/sets/' +
            setId +
            '/auto_creates/blank?expiredAt=' +
            expiredAt,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function createChecklistCleanSlate(
      setId,
      scope,
      startsAt,
      endsAt,
      valMin,
      valMax,
      checklistID,
      mode,
      albumType,
      ids,
    ) {
      var defered = $q.defer()

      if (!endsAt) {
        endsAt = ''
      }

      if (!checklistID) {
        checklistID = ''
      }

      if (!mode) {
        mode = 'full'
      }

      if (!albumType) {
        albumType = ''
      }

      if (!ids) {
        ids = ''
      }

      if (setId > 0) {
        $http
          .post(
            API.API_URL +
              'admin/checklist_definitions/sets/' +
              setId +
              '/auto_creates/clean_slate?startsAt=' +
              startsAt +
              '&scope=' +
              scope +
              '&endsAt=' +
              endsAt +
              '&valRankMin=' +
              valMin +
              '&valRankMax=' +
              valMax +
              '&checklistID=' +
              checklistID +
              '&mode=' +
              mode +
              '&albumType=' +
              albumType +
              '&ids=' +
              ids,
          )
          .success(defered.resolve)
          .error(defered.reject)
      } else {
        $http
          .post(
            API.API_URL +
              'admin/checklist_definitions/sets/auto_creates/clean_slate?startsAt=' +
              startsAt +
              '&scope=' +
              scope +
              '&endsAt=' +
              endsAt +
              '&valRankMin=' +
              valMin +
              '&valRankMax=' +
              valMax +
              '&checklistID=' +
              checklistID +
              '&mode=' +
              mode +
              '&albumType=' +
              albumType +
              '&ids=' +
              ids,
          )
          .success(defered.resolve)
          .error(defered.reject)
      }

      return defered.promise
    }

    function createChecklistRank(
      setId,
      scope,
      expiredAt,
      typeRank,
      rankMin,
      rankMax,
      bundleID,
      checklistID,
      mode,
      albumType,
      ids,
    ) {
      var defered = $q.defer()

      if (!expiredAt) {
        expiredAt = ''
      }
      if (!bundleID || isNaN(bundleID)) {
        bundleID = ''
      }
      if (!rankMax) {
        rankMax = 0
      }
      if (!checklistID) {
        checklistID = ''
      }
      if (!mode) {
        mode = 'full'
      }
      if (!albumType) {
        albumType = ''
      }

      if (!ids) {
        ids = ''
      }

      if (setId > 0) {
        $http
          .post(
            API.API_URL +
              'admin/checklist_definitions/sets/' +
              setId +
              '/auto_creates/rank?expiredAt=' +
              expiredAt +
              '&scope=' +
              scope +
              '&typeRank=' +
              typeRank +
              '&rankMin=' +
              rankMin +
              '&rankMax=' +
              rankMax +
              '&bundleID=' +
              bundleID +
              '&checklistID=' +
              checklistID +
              '&mode=' +
              mode +
              '&albumType=' +
              albumType +
              '&ids=' +
              ids,
          )
          .success(defered.resolve)
          .error(defered.reject)
      } else {
        $http
          .post(
            API.API_URL +
              'admin/checklist_definitions/sets/auto_creates/rank?expiredAt=' +
              expiredAt +
              '&scope=' +
              scope +
              '&typeRank=' +
              typeRank +
              '&rankMin=' +
              rankMin +
              '&rankMax=' +
              rankMax +
              '&bundleID=' +
              bundleID +
              '&checklistID=' +
              checklistID +
              '&mode=' +
              mode +
              '&albumType=' +
              albumType +
              '&ids=' +
              ids,
          )
          .success(defered.resolve)
          .error(defered.reject)
      }

      return defered.promise
    }

    function createChecklistHold(
      setId,
      scope,
      expiredAt,
      bundleID,
      checklistID,
      mode,
      albumType,
      ids,
    ) {
      var defered = $q.defer()

      if (!expiredAt) {
        expiredAt = ''
      }
      if (!bundleID || isNaN(bundleID)) {
        bundleID = ''
      }
      if (!checklistID) {
        checklistID = ''
      }
      if (!mode) {
        mode = 'full'
      }
      if (!albumType) {
        albumType = ''
      }

      if (!ids) {
        ids = ''
      }

      if (setId > 0) {
        $http
          .post(
            API.API_URL +
              'admin/checklist_definitions/sets/' +
              setId +
              '/auto_creates/hold?expiredAt=' +
              expiredAt +
              '&scope=' +
              scope +
              '&bundleID=' +
              bundleID +
              '&checklistID=' +
              checklistID +
              '&mode=' +
              mode +
              '&albumType=' +
              albumType +
              '&ids=' +
              ids,
          )
          .success(defered.resolve)
          .error(defered.reject)
      } else {
        $http
          .post(
            API.API_URL +
              'admin/checklist_definitions/sets/auto_creates/hold?expiredAt=' +
              expiredAt +
              '&scope=' +
              scope +
              '&bundleID=' +
              bundleID +
              '&checklistID=' +
              checklistID +
              '&mode=' +
              mode +
              '&albumType=' +
              albumType +
              '&ids=' +
              ids,
          )
          .success(defered.resolve)
          .error(defered.reject)
      }

      return defered.promise
    }

    function publishComingSoon(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + id + '/coming_soon')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      createChecklistBlank: createChecklistBlank,
      createChecklistCleanSlate: createChecklistCleanSlate,
      createChecklistRank: createChecklistRank,
      createChecklistHold: createChecklistHold,
      list: list,
      getChannelId: getChannelId,
      getOneChannelId: getOneChannelId,
      listProductLines: listProductLines,
      save: save,
      update: update,
      clone: clone,
      update2: update2,
      reorder: reorder,
      publish: publish,
      getId: getId,
      get: get,
      adminGet: adminGet,
      nextEdition: nextEdition,
      listRoyalties: listRoyalties,
      addRoy: addRoy,
      removeRoy: removeRoy,
      mintableCollectibles: mintableCollectibles,
      fixOrder: fixOrder,
      fixTop100: fixTop100,
      listTranslations: listTranslations,
      getTranslation: getTranslation,
      createTranslation: createTranslation,
      updateTranslation: updateTranslation,
      removeTranslation: removeTranslation,
      remove: remove,
      publishComingSoon: publishComingSoon,
      processBatch: processBatch,
    }
  }
})()
